import React, { createContext, useContext, useState } from 'react';
import { INDUSTRIES } from './data/industries';

const IndustryContext = createContext(null);

export function IndustryProvider({ children }) {
  const [industryId, setIndustryId] = useState(INDUSTRIES[0].id);
  const industry = INDUSTRIES.find((i) => i.id === industryId);

  return (
    <IndustryContext.Provider value={{ industry, industryId, setIndustryId, industries: INDUSTRIES }}>
      {children}
    </IndustryContext.Provider>
  );
}

export function useIndustry() {
  return useContext(IndustryContext);
}
